<script>
import bem from '@/utils/bem';
import pageUrls from '@/router/pageUrls';
import { mapState } from 'vuex';

const { companiesPage } = pageUrls;
const b = bem('sub-navigation');

export default {
  props: {
    companyId: {
      type: [String, Number],
      required: true,
    },
    activeTab: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({
      currentCompany: (state) => state.companies.currentCompany,
    }),
  },
  data() {
    return {
      tabs: [
        { key: 'page-content', label: 'Page Content', path: 'page-content' },
        { key: 'product-collections', label: 'Product Collections', path: 'product-collections' },
        { key: 'photo-galleries', label: 'Photo Galleries', path: 'photo-galleries' },
        { key: 'orders', label: 'Orders', path: 'orders' },
        { key: 'reports', label: 'Reports', path: 'reports' },
        { key: 'users', label: 'Users', path: 'users' },
        { key: 'deliveries', label: 'Deliveries', path: 'deliveries' },
        { key: 'processing', label: 'Processing', path: 'processing' },
        { key: 'help-center', label: 'Help Center', path: 'help-center' },
        { key: 'page-builder', label: 'Page Builder', path: 'page-builder' },
      ],
    };
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    navigateToTab(tabPath) {
      this.$router.push(`${companiesPage}/${this.companyId}/${tabPath}`);
    },
  },
};
</script>

<template>
  <div :class="b()">
    <div :class="b('header')">
      <div :class="b('header-left')">
        <span
          :class="b('label')"
          role="button"
          tabindex="0"
          @click="$router.push('/pod')"
          @keydown.enter="$router.push('/pod')"
        >POD ></span>
        <span :class="b('name')">{{ currentCompany?.displayName }}</span>
      </div>
      <img
        v-if="currentCompany?.logoImageUri"
        :src="currentCompany.logoImageUri"
        :alt="currentCompany?.displayName"
        :class="b('header-logo')"
      />
    </div>
    <div :class="b('container')">
      <button
        v-for="tab in tabs"
        :key="tab.key"
        :class="b('tab', { 'active': this.activeTab === tab.key })"
        @click="navigateToTab(tab.path)"
      >
        <span
          :class="b('tab-label',{ 'active': this.activeTab === tab.key })"
          >
            {{ tab.label }}
          </span>
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables';
@import '@/styles/media';

.sub-navigation {
  position: relative;
  background: #F5F5F5;

  @include mediaMinMax(1025, $normal) {
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 35px 40px 28px;
    background-color: #fff;

    @include mediaMinMax(1025, $normal) {
      padding: vw-full(35) vw-full(40) vw-full(28);
    }
  }

  &__header-left {
    display: flex;
    align-items: baseline;
    gap: 8px;

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(8);
    }
  }

  &__label {
    color: var(--light-gray, #7F7F7F);
    font-family: Montserrat, sans-serif;
    font-size: 28px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    cursor: pointer;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(28);
    }
  }

  &__name {
    color: var(--Dark, #293241);
    font-family: Montserrat, sans-serif;
    font-size: 28px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-transform: uppercase;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(28);
    }
  }

  &__header-logo {
    max-height: 60px;
    max-width: 200px;
    object-fit: contain;

    @include mediaMinMax(1025, $normal) {
      max-height: vw-full(60);
      max-width: vw-full(200);
    }
  }

  &__container {
    display: flex;
    gap: 0;
    position: relative;
    padding: 0 40px;
  }

  &__tab {
    padding: 0 32px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--light-gray, #7F7F7F);
    text-align: center;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
    border: none;
    background: transparent;

    @include mediaMinMax(1025, $normal) {
      padding: 0 vw-full(32);
      height: vw-full(48);
      font-size: vw-full(16);
    }

    &:hover {
      background: #e8e8e8;
    }

    &_active {
      position: relative;

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 60px;
        border-radius: 0 0 20px 20px;
        background: var(--pro-dark-gray, #242424);
        color: #fff;
        z-index: 1;

        @include mediaMinMax(1025, $normal) {
          height: vw-full(60);
          border-radius: 0 0 vw-full(20) vw-full(20);
        }
      }
    }
  }

  &__tab-label {
    &_active {
      z-index: 2;
      color: #fff;
    }
  }
}
</style>
